<template>
  <div class="body" @click="handleClick">
    <video id="background-video" autoplay muted loop playsinline>
      <source src="/video/loop_bg.mp4" type="video/mp4" />
    </video>
    <video id="rare-overlay-video" ref="rareOverlay" src="/video/rare_overray.mp4" playsinline></video>
    <audio id="bgm" ref="bgm" src="/video/bgm.mp3"></audio>

    <div class="screen-frame">
      <div class="animation-card-container" ref="cardContainer"></div>
      <div class="animation-text-area"><h1>TAP</h1></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OpenCard',

  props: {
    cards: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      currentIndex: 0,
      totalCards: 10,
      isTransitioning: false,
      bgmStarted: false,
      currentCard: null,
    };
  },
  mounted() {
    this.container = this.$el.querySelector('.animation-card-container');
    this.showNextCard(false);
  },
  methods: {
    createCard(cardData) {
      // const num = String(cardData + 1).padStart(3, '0');
      const card = document.createElement('div');
      card.dataset.rarity = cardData.rarity;
      card.className = 'animation-card';
      card.innerHTML = `
        <div class="animation-card-inner">
          <div class="animation-card-front">
            <img src="${cardData.frontImage}" alt="カード表">
          </div>
          <div class="animation-card-back">
            <img src="/img/card_back.png" alt="カード裏">
          </div>
        </div>
      `;
      this.$refs.cardContainer.appendChild(card);
      return card;
    },
    showNextCard(autoFlip = false) {
      if (this.currentIndex < this.cards.length) {
        const cardData = this.cards[this.currentIndex];
        this.currentIndex += 1;
        this.currentCard = this.createCard(cardData);
        if (autoFlip) {
          this.currentCard.addEventListener(
            'animationend',
            (e) => {
              if (e.animationName === 'fadeInUp') {
                this.currentCard.classList.add('flipped');
                const { rarity } = this.currentCard.dataset;
                if (rarity === 'rare') {
                  this.showRareEffect();
                }
              }
            },
            { once: true },
          );
        }
      } else {
        this.$emit('handleOpenCardEnd');
      }
    },
    showRareEffect() {
      const img = this.currentCard.querySelector('.animation-card-back img');
      img.classList.add('bright-flash');
      void img.offsetWidth;
      img.classList.replace('bright-flash', 'remove-bright-flash');

      const overlay = this.$refs.rareOverlay;
      overlay.style.display = 'block';
      overlay.currentTime = 0;
      overlay.play();
      overlay.onended = () => {
        overlay.style.display = 'none';
      };
    },
    handleClick() {
      if (!this.bgmStarted) {
        this.$refs.bgm.play();
        this.bgmStarted = true;
      }
      if (this.isTransitioning || !this.currentCard) return;

      if (!this.currentCard.classList.contains('flipped')) {
        this.currentCard.classList.add('flipped');
        const { rarity } = this.currentCard.dataset;
        if (rarity === 'rare') {
          this.showRareEffect();
        }
      } else {
        this.isTransitioning = true;
        this.currentCard.classList.add('slide-out');
        setTimeout(() => {
          this.currentCard.remove();
          this.isTransitioning = false;
          this.showNextCard(true);
        }, 500);
      }
    },
    skipCard() {
      // 全カードを表示 → 一気に消す
      const container = this.$el.querySelector('.animation-card-container');
      container.innerHTML = ''; // 一旦すべて削除
      // すぐ終了イベントを emit
      this.$emit('handleOpenCardEnd');
    },
  },
};
</script>

<style lang="scss">
.body {
  margin:0;
  padding:0;
  overflow:hidden;
  background:black;
  width:100vw;
  height:100vh;
  display:flex;
  justify-content:center;
  align-items:center;
  position:relative
}
#background-video {
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  object-fit:cover;
}
#rare-overlay-video {
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  object-fit:cover;
  mix-blend-mode:screen;
  z-index:10;
  display:none;
  pointer-events:none
}
.screen-frame {
  position:relative;
  width:100%;
  max-width:1080px;
  height:100%;
  max-height:1920px;
  aspect-ratio:9/16;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  overflow:hidden
}
.animation-card-container {
  position:relative;
  width:50%;
  aspect-ratio:2/3;
  max-width:360px;
  min-width:180px
}
.animation-text-area {
  margin-top:100px;
  text-align:center;
  color:white;
  font-family:Arial,sans-serif;
  z-index:1
}
.animation-text-area h1 {
  font-size:clamp(24px,6vw,60px);
  margin:0
}
.animation-card {
  width:100%;
  height:100%;
  position:absolute;
  perspective:1200px;
  opacity:0;
  transform:translateY(30px);
  animation:fadeInUp 0.5s ease-out forwards
}
.animation-card-inner {
  width:100%;
  height:100%;
  position:relative;
  transform-style:preserve-3d;
  transition:transform 0.8s ease-in-out
}
.animation-card.flipped .animation-card-inner {
  transform:rotateY(180deg)
}
.animation-card.slide-out {
  animation:slideOut 0.5s ease-in-out forwards;
  pointer-events:none
}
.animation-card-front,.animation-card-back {
  width:100%;
  height:100%;
  position:absolute;
  top:0;
  left:0;
  backface-visibility:hidden;
  border-radius:12px;
  overflow:hidden
}
.animation-card-front img,.animation-card-back img {
  width:100%;
  height: auto;
  object-fit: contain;
  border-radius: 10px;
}
.animation-card-back {
  transform:rotateY(0deg)
}
.animation-card-front {
  transform:rotateY(180deg)
}
.bright-flash {
  filter:brightness(6) saturate(0) opacity(0.95)
}
.remove-bright-flash {
  filter:brightness(1) saturate(1) opacity(1);
transition:filter 2s ease-in-out
}
@keyframes fadeInUp{from{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}
@keyframes slideOut{from{opacity:1;transform:translateX(0)}to{opacity:0;transform:translateX(100%)}}
</style>
